// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.section-divider[data-v-338d9cd2] {
        display: flex;
        align-items: center;
        gap: 0.75rem;
}
.section-line[data-v-338d9cd2] {
        flex: 1;
        height: 1px;
        background-color: var(--bulma-border);
}
`, "",{"version":3,"sources":["webpack://./app/Frontend/Common/SectionDivider.vue"],"names":[],"mappings":";AAkBI;QACI,aAAa;QACb,mBAAmB;QACnB,YAAY;AAChB;AAEA;QACI,OAAO;QACP,WAAW;QACX,qCAAqC;AACzC","sourcesContent":["<template>\n    <div class=\"section-divider\">\n        <span class=\"icon-text has-text-grey heading mb-0\">\n            <span v-if=\"icon\" class=\"icon\"><i :class=\"icon\"></i></span>\n            <span>{{ label }}</span>\n        </span>\n        <div class=\"section-line\"></div>\n    </div>\n</template>\n\n<script setup lang=\"ts\">\n    defineProps<{\n        label: string;\n        icon?: string;\n    }>();\n</script>\n\n<style scoped>\n    .section-divider {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n    }\n\n    .section-line {\n        flex: 1;\n        height: 1px;\n        background-color: var(--bulma-border);\n    }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
